import styled, { keyframes } from "styled-components";
import profilImg from "../public/profileImg.png";
import { GithubIcon, LinkedinIcon } from "../icons";
import { useNavigate } from "react-router-dom";
import Header, { HEADER_HEIGHT } from "../public/Header";
import Copyright from "../public/Copyright";

const StyledGithubIcon = styled(GithubIcon)`
  width: 1.25rem;
  height: 1.25rem;
`;

const StyledLinkedinIcon = styled(LinkedinIcon)`
  width: 1.25rem;
  height: 1.25rem;
  color: #0077b5;
`;

// 부드럽게 나타나는 애니메이션
const fadeIn = keyframes` 
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Body = styled.div`
  width: 100vw;
  height: 100vh;
  /* 배경을 단색 대신 세련된 그라데이션으로 변경 */
  background: linear-gradient(135deg, ${props => props.theme.ROOT_BACKGROUND.FIRST} 0%, ${props => props.theme.ROOT_BACKGROUND.LAST} 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Pretendard', -apple-system, sans-serif;
  overflow: hidden;
`;

const Box = styled.div`
  width: 35rem; /* 너비를 살짝 줄여서 컴팩트하게 */
  padding: 3rem 2rem;
  background: ${props => props.theme.BOX_BACKGROUND};
  backdrop-filter: blur(10px); /* 유리 효과 */
  border-radius: 1.5rem;
  border: 1px solid ${props => props.theme.BOX_BORDER};
  box-shadow: 0 20px 25px -5px ${props => props.theme.BOX_SHADOW.FIRST}, 0 10px 10px -5px ${props => props.theme.BOX_SHADOW.LAST};
  animation: ${fadeIn} 0.8s ease-out;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${props => props.theme.CONTENT.TITLE_COLOR};
  text-align: center;
  margin-bottom: 0.5rem;
  letter-spacing: -0.05rem;
`;

const ImgContainer = styled.img`
  display: block;
  margin: 1.5rem auto;
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid white;
  box-shadow: 0 2px 4px -1px ${props => props.theme.BOX_SHADOW.FIRST}, 0 2px 4px -1px ${props => props.theme.BOX_SHADOW.LAST};
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const Section = styled.div`
  margin-bottom: 1.5rem;
`;

const SubTitle = styled.h2`
  font-size: 0.9rem;
  font-weight: 700;
  color: ${props => props.theme.MENU.SUBTITLE_COLOR};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: 0.5rem;
  border-bottom: 2px solid ${props => props.theme.CONTENT.UPPER_BOTTOM_BORDER};
  padding-bottom: 0.2rem;
`;

const Content = styled.div`
  font-size: 0.95rem;
  color: ${props => props.theme.MENU.ITEM_COLOR};
  line-height: 1.6;
  word-break: keep-all;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 0.4rem;
    display: flex;
    align-items: flex-start;
    font-size: 0.9rem;
    color: ${props => props.theme.MENU.ITEM_COLOR};
    
    &::before {
      content: "•";
      color: ${props => props.theme.ABOUT_ME.LI};
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 2rem;

  a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: ${props => props.theme.ABOUT_ME.FONT_COLOR};
    font-weight: 500;
    transition: color 0.2s;

    &:hover {
      color: ${props => props.theme.ABOUT_ME.HOVER.FONT_COLOR};
    }
  }
`;

function AboutMe() {
  const navigate = useNavigate();

  return (
    <Body>
      <Header title="Lamiro"/>
      <Box>
        <Title>Ko Taehyeon</Title>
        <ImgContainer src={profilImg} alt="Profile" />
        
        <Section>
          <SubTitle>About Me</SubTitle>
          <Content>
            2003년생, 동국대학교에서 인공지능을 전공하고 있습니다. 
            <strong> ML/DL, NLP, Computer Vision</strong> 분야에 깊은 관심을 가지고 있으며, 
            배움의 깊이를 더하기 위해 석사 과정을 목표로 정진 중입니다.
          </Content>
        </Section>

        <Section>
          <SubTitle>Education & Experience</SubTitle>
          <List>
            <li>B.S. in Artificial Intelligence, Dongguk Univ. (2022 ~ )</li>
            <li>ROKAF Cyber System Operation (2023.08 ~ 2025.05)</li>
          </List>
        </Section>

        <SocialLinks>
          <a href="https://github.com/lamiro3" target="_blank" rel="noreferrer">
            <StyledGithubIcon/> Github
          </a>
          <a href="https://www.linkedin.com/in/ko-taehyeon-25463a3aa/" target="_blank" rel="noreferrer">
            <StyledLinkedinIcon/> LinkedIn
          </a>
        </SocialLinks>
        <Copyright />
      </Box>
    </Body>
  );
}

export default AboutMe;